import React, { useState, useEffect } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import "./ResetPassword.css";
import CryptoJS from "crypto-js";
import ButtonSolid from "../elements/Button/ButtonSolid";
import Swal from "sweetalert2";

const ResetPasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [resetToken, setResetToken] = useState("");
  const location = useLocation(); // Get the current location object

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    setResetToken(token);
  }, [location]);

  const handleSave = () => {
    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }
    setError("");

    const data = { token: resetToken, password, confirmPassword };
    console.log("Reset data:", data);

    handleResetPassword();
  };
  const [isResponseSend, setIsResponseSend] = useState(false);
  const handleResetPassword = async () => {
        try {
          setIsResponseSend(true);
            const jsonData = { resetToken: resetToken,password:  password,confirm_password: confirmPassword };
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(jsonData), process.env.REACT_APP_SECRETKEY).toString();
            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/resetPassword`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data: encryptedData }),
              });
            const responsedata = await response.json();
            setIsResponseSend(false);
    
            const decryptedData = JSON.parse(CryptoJS.AES.decrypt(responsedata.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
            // console.log(decryptedData);
            if (!response.ok) {
              const errorMessage = responsedata.error || "Something went wrong";
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: errorMessage,
              });
              throw new Error(errorMessage);
            } else {
              Swal.fire({
                icon: 'success',
                title: 'Password Reset successfully',
                text: decryptedData.message,
              }).then(() => {
                window.location.href = "/Signin";
              });
            }
        } catch (error) {
          console.error("Error:", error);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.message,
          });    
        }
  }

  return (
    <>
    <div className="reset-password-custom-container">
      <h2 className="reset-password-custom-title">Reset Your Password</h2>
      {isResponseSend ? (
        <div className="flex flex-column justify-center items-center">
          <div className="loader-spinner"></div>
          <div className="loader-text">Resetting Your Password, Please Wait...</div>
        </div>
      ):(<>
      <div className="reset-password-custom-form-group">
        <label className="reset-password-custom-label">New Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="reset-password-custom-input-field"
          placeholder="Enter new password"
        />
      </div>
      <div className="reset-password-custom-form-group">
        <label className="reset-password-custom-label">Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="reset-password-custom-input-field"
          placeholder="Re-enter new password"
        />
        {error && <p className="reset-password-custom-error-message">{error}</p>}
      </div>
      <ButtonSolid
        className=""
        onClick={handleSave}
        content="Save"
      />
      </>)}
    </div>
    </>
  );
};

export default ResetPasswordPage;
